import React from "react";
import { cx } from "../utils";

/** List wrapper for CcEvaluationCard timeline entries. */
const CcEvaluationTimeline = ({ className, children, ...props }) => (
  <ul className={cx("cc-evaluation-timeline", className)} {...props}>
    {children}
  </ul>
);

export default CcEvaluationTimeline;
